import { css } from "@emotion/react";
import { kitText } from "../../../styles";

export const styles = {
  stepsLayout: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-24);
    ${kitText.variant.body};

    .kit-Uploader {
      margin-top: var(--spacing-32);
    }
  `,

  step: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-8);
    padding-bottom: var(--spacing-24);
    width: 100%;
  `,

  stepNum: css`
    color: var(--color-tertiary);
    ${kitText.style.bold}
  `,

  stepTitle: css`
    color: var(--color-primary);
    ${kitText.style.bold}
  `,

  stepContent: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-16);
    color: var(--color-secondary);
    width: 100%;
  `,

  bottomBorder: css`
    border-bottom: 1px solid var(--color-border-secondary);
  `
};
